import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deleteExpense } from '../api/expensesApi';

export default function useDeleteExpense() {
    return useMutation({
        mutationFn: deleteExpense,
        onSuccess: () => toast.success('Expense deleted'),
        onError: (err) => toast.error(err?.message ?? 'Failed to delete expense'),
    });
}
